import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { SALES_API_PATH } from "@/modules/Sales/constants";
import { SalesProductivityParamsRequestModel } from "../models/FetchSalesProductivityParams.request";
import { formatString } from "@/core/utils/helpers";

class SalesService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getSalesSnapshot(salesmanId: string): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(SALES_API_PATH.GET_SALES_USAGE_SNAPSHOT, salesmanId),
    );
  }

  public getSalesProductivity(
    salesmanId: string,
    payload: SalesProductivityParamsRequestModel,
  ): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(SALES_API_PATH.GET_SALES_PRODUCTIVITY, salesmanId),
      payload,
    );
  }

  public getSalesMyTeam(): Promise<ICoreResponse> {
    return this.restClient.get(SALES_API_PATH.SALES_MY_TEAM);
  }
}

export default SalesService;
